module.exports = __webpack_public_path__ + "static/img/A73.bff900a4.jpg";